
import {Component, Vue, Watch} from "vue-property-decorator";
import CustomChipLink from "@/components/CustomChipLink.vue";
import { ROWS_PER_PAGE } from "@/utils/constants";

@Component({
  components: {CustomChipLink},
})
export default class Blockchain extends Vue {

  private transfers: object[] = [];
  private headers: object[] = [
    {value: "createdAt", sortable: false},
    {value: "transfer", sortable: false},
    {value: "hash", sortable: false},
    {value: "jobId", sortable: false},
    {value: "state", sortable: false},
    {value: "verify", sortable: false},
  ];

  private loading: boolean = true;
  private showDialog: boolean = false;
  private INVALID: string = "";
  private selectedJob: any = null;

  private pagination: any = {
    page: 1,
    itemsPerPage: 15,
    totalItems: 15,
  };

  private ROWS_PER_PAGE = ROWS_PER_PAGE;

  @Watch("pagination", {deep: true})
  public handler() {
    this.loading = true;
    this.getTransfers().then(() => this.loading = false);
  }

  private getStateColor(state: string): string {
    switch (state) {
      case "QUEUED":
        return "#FFA726";
      case "ATTEMPTING":
        return "#42A5F5";
      case "VERIFYING_ON_CHAIN":
        return "#42A5F5";
      case "VERIFIED_ON_CHAIN":
        return "#00cc00";
      case "ABANDONED":
        return "#DD2C00";
      default:
        return "default";
    }
  }

  private getTransfers() {
    return this.$store.dispatch("admin/keyTransfers/getTransfers", {query: this.pagination})
      .then((res) => {
        this.transfers = res.transfers;
        this.pagination.totalItems = res.count;
      });
  }

  private truncateHash = (str: string): string => {
    const NUM = 8;
    if (str.length <= NUM) {
      return str;
    }
    return str.substring(0, NUM);
  }

  private verify(item: any) {
    return this.$store.dispatch("blockchain/admin/getProof", {jobId : item.jobId})
      .then((res) => {
        if (res) {
          this.selectedJob = res;
          this.showDialog = true;
        }
      }).catch(() => {
        this.selectedJob = item.BlockchainJob;
        this.showDialog = true;
      });
  }

  private reset(): void {
    this.showDialog = false;
  }

}
